import { Link } from "react-router-dom";
import BrandLogo from "./BrandLogo";

export default function PublicFooter() {
  return (
    <footer className="site-footer">
      <div className="container footer-shell">
        <div className="footer-brand-block">
          <BrandLogo compact />
          <p className="muted-text">
            AffiTrack is an affiliate tracking and analytics platform for solo operators and mentor-led teams.
          </p>
        </div>

        <div className="footer-grid">
          <div>
            <h3>Support</h3>
            <p>Email: support@affitrack.net</p>
            <p>Response goal: within 2 business days</p>
          </div>

          <div>
            <h3>Billing</h3>
            <p>Subscriptions renew monthly until canceled.</p>
            <p>You can cancel before your next billing cycle to avoid future charges.</p>
          </div>

          <div>
            <h3>Refunds</h3>
            <p>Refund requests are reviewed case by case for duplicate charges or billing errors.</p>
            <p>Promotional or partial-period refunds are not guaranteed.</p>
          </div>

          <div>
            <h3>Policies</h3>
            <p><Link to="/terms">Terms of Service</Link></p>
            <p><Link to="/privacy">Privacy Policy</Link></p>
            <p><Link to="/account-deletion">Account Deletion</Link></p>
          </div>
        </div>
      </div>
    </footer>
  );
}
